import { Box, styled, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import MainLayout from '../components/layout/MainLayout';
import { getUrlParams } from '../utils/url';
import { LmsType } from '../components/classroom/types';

const StyledMainDiv = styled(Box)`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
`;

const StyledTextDiv = styled(Box)`
    flex: 1;
    margin-top: 40px;
`;

const LmsAuthSuccess = () => {
    const { ready, t } = useTranslation('lms_sync');
    const { lms_type: lmsType } = getUrlParams();
    const getLmsName = () => {
        switch (lmsType) {
            case LmsType.Blackboard:
                return 'Learn';
            case LmsType.Canvas:
                return 'Canvas';
            case LmsType.D2l:
                return 'Brightspace';
            case LmsType.Moodle:
                return 'Moodle';
            case LmsType.OpenLms:
                return 'OpenLMS';
            case LmsType.Schoology:
                return 'Schoology';
            default:
                return t('lms-auth-default-lms-name');
        }
    };

    if (ready) {
        return (
            <MainLayout title={t('lms-auth-title')}>
                <StyledMainDiv>
                    <StyledTextDiv>
                        <Typography variant="h1">{t('lms-auth-success')}</Typography>
                    </StyledTextDiv>
                    <Typography>{t('lms-auth-directions', { lmsName: getLmsName() })}</Typography>
                </StyledMainDiv>
            </MainLayout>
        );
    }

    return null;
};

export default LmsAuthSuccess;
